/* Index page
 -------------------------------------------------- */
let Pagination = function () {

    let initPagination = function () {

        $('body').delegate('button[data-pagination]', 'click', function () {

            let btn = $(this);
            let data = btn.data();
            let template = data.template ? data.template : 'list';

            let requestData = {
                page: data.nextpage,
                template: template,
            };

            if(data.query){
                requestData.search = data.query;
            }

            $.get(window.location.href, requestData, function (result) {
                btn.replaceWith(result.html);
                window.lazyLoadInstance.update();
            });
        });

    };

    return {
        //main function to initiate the module
        init: function () {
            initPagination();
        }
    };
}();

$(document).ready(function () {
    window.Pagination = Pagination;
    window.Pagination.init();
});

